
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/partner-with-us",
      function () {
        return require("private-next-pages/severalbrands/partner-with-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands/partner-with-us"])
      });
    }
  